// extracted by mini-css-extract-plugin
module.exports = {"feature-section":"OR_f5","feature-headline":"_3A1PA","feature-text":"_1sRxJ","input-field-wrapper":"_28oWK","submit-btn":"_2h0YU","error-text":"_1O6zA","success-text":"MFlrA"};